import { useDispatch, useSelector } from 'react-redux'

import ReactSelect from '@/components/form/ReactSelect'
import { Translation } from '@/components/i18n/Translation'
import { getStatusCounter, getStatusFilter, setStatusFilter } from '@/ducks/shopOrdersReducer'
import { numberFormat } from '@/util/formatters/numbers'
import { getShopOrderStatusTextId } from '@/util/orders'

const StatusSelect = () => {
  const dispatch = useDispatch()

  const statusCounter = useSelector(getStatusCounter)
  const statusFilter = useSelector(getStatusFilter)
  // @ts-ignore
  const sortFn = (x, y) => x - y
  const keys = Object.keys(statusCounter)
    .map(key => parseInt(key))
    .sort(sortFn)

  const options = keys.map(status => ({
    value: status,
    label: (
      <>
        <Translation id={getShopOrderStatusTextId(status)} />{' '}
        <b>{numberFormat(statusCounter[status])}</b>
      </>
    ),
  }))

  return (
    <ReactSelect
      className="react-select"
      options={options}
      value={statusFilter}
      // @ts-ignore
      onChange={value => dispatch(setStatusFilter(value))}
    />
  )
}

export default StatusSelect
